import {
    AlertBanner,
    ButtonSubmit, ColourSolid,
    DateOfBirth, FormWrapperLabel,
    PasswordMatch, Select, TelephoneControl,
    ToggleSwitch, ToggleType
} from "@twigsby/frontend-framework";
import React, {memo} from "react";
import {SignUpSectionWrapperInterface} from "../../Types/SignUp/SignUpSection";
import AddressLookup from "../AddressLookup";
import {Controller, FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import {noDefaultSelect} from "../ValidationRules";

const defaultValues = {
    forename: "",
    surname: "",
    email: "",
    password: "",
    passwordMatch: "",
    address: "",
    dob: "-1",
    telephone: "",
    mobile: "",
    accountType: "-1",
    reasonForUsingService: "",
    agreeToGDPR: ""
};

const AccountCreation: React.FC<SignUpSectionWrapperInterface> = memo((props) => {
    const formMethods = useForm({
        defaultValues: defaultValues,
        mode: "onChange"
    });

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setValue,
        formState: { errors },
    } = formMethods;

    return (
        <div className={`sign-up-section ${props.visible ? 'mb-xxxl' : 'sign-up-section-hide'} ${props.complete && !props.visible ? 'sign-up-section-complete mt-xs' : 'mt-lg'}`}>
        {/*    <SignUpSectionHeader label={'User Details'} completeLabel={'User Holder'} complete={props.complete} visible={props.visible} />
*/}
            <h3 className={'mt-lg mb-xs text-center'}>Account Details</h3>

            <FormProvider {...formMethods}>
                <form className={'form-horizontal form-horizontal-large'} onSubmit={handleSubmit(data => alert(JSON.stringify(data)))}>
                    <fieldset className={'flex-column flex-gap-md'}>
                        <AlertBanner title={`Please note, you'll be required to <a href="https://www.ukpostbox.com/how-it-works/identity-verification" target="_blank" rel="noopener">verify your identity</a> before your account is activated`} colourMod={ColourSolid.Primary} />
    {/*
                        <EmailControl
                            label={'Email/Username'}
                            register={register}
                            setValue={setValue}
                            getValues={getValues}
                            errors={errors}
                            getFieldState={getFieldState}
                            forwardCallback={() => null}
                        />*/}

                        <PasswordMatch
                            name={'password'}
                            upperMinLength={1}
                            numberMinLength={1}
                            lowerMinLength={1}
                            charMinLength={7}
                        />

                        <FormWrapperLabel
                            label={'Forename'}
                            invalid={errors.forename && errors.forename?.message !== ''}
                            validationMessage={errors.forename?.message as string}
                        >
                            <input type='text' aria-invalid={errors.forename ? 'true' : 'false'} {...register('forename', { required: "This is a required field", minLength: { value: 2, message: 'Too short'}, maxLength: 10 })} />
                        </FormWrapperLabel>

                        <FormWrapperLabel
                            label={'Surname'}
                            invalid={errors.surname && errors.surname?.message !== ''}
                            validationMessage={errors.surname?.message as string}
                        >
                            <input type='text' aria-invalid={errors.surname ? 'true' : 'false'} {...register('surname', { required: "This is a required field", minLength: { value: 2, message: 'Too short'}, maxLength: { value: 20, message: 'Too long'} })} />
                        </FormWrapperLabel>

                        <AddressLookup
                            label={'Current Residential Address'}
                            register={register}
                            setValue={setValue}
                            getValues={getValues}
                            errors={errors}
                        />

                        <DateOfBirth
                            label={'Date of Birth'}
                            name={'dob'}
                        />

                        <TelephoneControl
                            name="telephone"
                            placeholder={'Telephone Number'}
                            onBlurCallback={() => null}
                        />

                        <TelephoneControl
                            name="mobile"
                            placeholder={'Mobile Number'}
                            onBlurCallback={() => null}
                        />

                        <FormWrapperLabel
                            label={'User Type'}
                            invalid={errors.accountType && errors.accountType?.message !== ''}
                            validationMessage={errors.accountType?.message as string}
                        >
                            <Select {...register('accountType', { required: true, validate: () => noDefaultSelect(getValues().accountType, 'User Type is Required') })} name='accountType' aria-invalid={errors.accountType ? 'true' : 'false'} >
                                <option value={-1} disabled selected hidden>Select Type...</option>
                                <option value={0}>Business</option>
                                <option value={1}>Personal</option>
                            </Select>
                        </FormWrapperLabel>

                        <FormWrapperLabel
                            label={'Reason for using the service'}
                            invalid={errors.reasonForUsingService && errors.reasonForUsingService?.message !== ''}
                            validationMessage={errors.reasonForUsingService?.message as string}
                        >
                            <textarea {...register("reasonForUsingService", { required: 'Reason is required', minLength: { value: 5, message: 'Too short'}})} name='reasonForUsingService' rows={5} ></textarea>
                        </FormWrapperLabel>

                        <Controller
                            control={control}
                            name="agreeToGDPR"
                            rules={{ required: "You must Agree" }}
                            render={({ field }) =>
                                <ToggleSwitch
                                    inForm={true}
                                    type={ToggleType.Checkbox}
                                    onChange={(e) => field.onChange(e)}
                                    invalid={errors.agreeToGDPR && errors.agreeToGDPR?.message !== ''}
                                    validationMessage={errors.agreeToGDPR?.message as string}
                                    name={'GDPR'}
                                    label={'In line with the GDPR we want you to know exactly how our service works, including why and how we process your personal information. Please confirm that you have read and accept our <a target="_blank" style="color:#689EB9" href="https://www.ukpostbox.com/legals/terms-and-conditions">terms and conditions</a> and <a target="_blank" style="color:#689EB9" href="https://www.ukpostbox.com/legals/privacy-policy">privacy policy</a>.'}/>
                            } />

                        <ButtonSubmit title={'Continue'} colour={ColourSolid.Primary} fullWidth={true} />

                    </fieldset>
                </form>
            </FormProvider>
        </div>
    )
})

export default AccountCreation
